/* THE DESK DAY · NAPE advertorial A1
   Small, dependency-free. Everything on the page reads fine without it. */
(function () {
  'use strict';

  /* ── Config ──────────────────────────────────────────────────────────────
     ONE conversion destination for the whole page. Every [data-cta] that is
     not an in-page link (#demo) is pointed here. */
  var CONFIG = {
    // On Shopify the template passes the real product URL in window.NAPE_ADV. Standalone, set it here.
    productUrl: (window.NAPE_ADV && window.NAPE_ADV.productUrl) || 'https://trynape.com/',
    // query parameters carried from the ad click through to the store
    passParams: /^(utm_|fbclid$|gclid$|ttclid$|msclkid$|ad_id$|adset_id$|campaign_id$)/i,
    defaultParams: { utm_source: 'deskday', utm_medium: 'article', utm_campaign: 'a1' }
  };

  var doc = document;
  doc.documentElement.classList.add('js');

  function track(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    (window.dataLayer = window.dataLayer || []).push(payload);
    try { doc.dispatchEvent(new CustomEvent('advertorial:' + name, { detail: payload })); } catch (e) {}
  }

  /* ── CTA links: destination + parameter pass-through + click events ───── */
  function buildUrl(ctaId) {
    var url;
    try { url = new URL(CONFIG.productUrl, location.href); } catch (e) { return CONFIG.productUrl; }
    var incoming = new URLSearchParams(location.search);
    var carried = false;
    incoming.forEach(function (value, key) {
      if (CONFIG.passParams.test(key)) { url.searchParams.set(key, value); carried = true; }
    });
    if (!carried) {
      Object.keys(CONFIG.defaultParams).forEach(function (key) { url.searchParams.set(key, CONFIG.defaultParams[key]); });
    }
    url.searchParams.set('utm_content', ctaId);
    return url.toString();
  }

  doc.querySelectorAll('[data-cta]').forEach(function (link) {
    var id = link.getAttribute('data-cta');
    var inPage = (link.getAttribute('href') || '').charAt(0) === '#' && link.getAttribute('href').length > 1;
    if (!inPage) link.href = buildUrl(id);
    link.addEventListener('click', function () {
      track('cta_click', { cta_id: id, cta_type: inPage ? 'in_page' : 'product' });
    });
  });

  /* ── Reading progress + scroll-depth events ───────────────────────────── */
  var bar = doc.querySelector('[data-progress]');
  var article = doc.querySelector('.article');
  var marks = [25, 50, 75, 100];
  var ticking = false;

  function onScroll() {
    ticking = false;
    if (!article) return;
    var total = article.offsetHeight - window.innerHeight;
    var done = total > 0 ? Math.min(1, Math.max(0, (window.scrollY - article.offsetTop) / total)) : 0;
    if (bar) bar.style.transform = 'scaleX(' + done.toFixed(4) + ')';
    while (marks.length && done * 100 >= marks[0]) track('read_depth', { percent: marks.shift() });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* ── In-view behaviour: timeline figures lean, demo video plays ───────── */
  var timelineItems = doc.querySelectorAll('.timeline__item');
  var videos = doc.querySelectorAll('video[data-autoplay]');

  if (!('IntersectionObserver' in window)) {
    timelineItems.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var leanObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var index = Array.prototype.indexOf.call(timelineItems, entry.target);
      setTimeout(function () { entry.target.classList.add('is-in'); }, 120 * Math.max(0, index));
      leanObserver.unobserve(entry.target);
    });
  }, { threshold: 0.6 });
  timelineItems.forEach(function (el) { leanObserver.observe(el); });

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting && !reducedMotion) {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.35 });
  videos.forEach(function (video) {
    if (reducedMotion) video.setAttribute('controls', '');
    videoObserver.observe(video);
  });

  /* section views, for funnel reporting (reveal → demo → offer → final) */
  var seen = {};
  var sectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var id = entry.target.id;
      if (entry.isIntersecting && !seen[id]) { seen[id] = true; track('section_view', { section: id }); }
    });
  }, { threshold: 0.25 });
  ['nape', 'proof', 'demo', 'offer', 'final'].forEach(function (id) {
    var el = doc.getElementById(id);
    if (el) sectionObserver.observe(el);
  });
})();
